require('./styles/index.scss');
import tippy from 'tippy.js';

const tooltipData = require('./assets/tooltips');

const edgeServices = ["fieldservices", "manufacturing", "engineering", "repair", "generation", "distribution", "drives", "motors", "machineoptimization", "automation", "machinemonitoring"
];

document.addEventListener('DOMContentLoaded', () => {
    // loop through all tooltip data and activate tooltips
    for (let tooltip in tooltipData) {
        tippy(document.getElementById(tooltip), {
            content: tooltipData[tooltip],
            interactive: true,
            arrow: true,
            delay: [null, 200],
            theme: edgeServices.includes(tooltip) ? 'edge' : ''
        });
    }

    document.getElementById('FLANDERSALL').addEventListener('click', () => {
        window.open('https://google.com', '_blank');
    })
});
